import { useParams } from "react-router-dom";
import { EventView } from "@/components/nodes/EventView";
import { MetricView } from "@/components/nodes/MetricView";
import { useStore } from "@/model/store";
import { NotFoundPage } from "./NotFoundPage";

export function NodePage() {
	const { nodeId } = useParams();
	const node = useStore((s) => (nodeId ? s.world.nodes[nodeId] : undefined));
	if (!node) return <NotFoundPage what="event or metric" />;
	// Keyed so drafts and local state reset when navigating between nodes.
	return node.kind === "event" ? <EventView key={node.id} node={node} /> : <MetricView key={node.id} node={node} />;
}
